import styled from 'styled-components'
// themes
import { colors } from 'themes'

export const ChartWrapper = styled.div<{ height: number }>`
  display: flex;
  flex-direction: column;
  padding: 16px;
  border-radius: 6px;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
  height: ${({ height }) => height}px;
  background-color: ${colors.white100};
  box-sizing: border-box;
  overflow: hidden;
`

export const ChartHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin-bottom: 8px;
`

export const ChartTitle = styled.div`
  flex: 1;
  min-width: 0;
  font-size: 16px;
  font-weight: 600;
`

export const ChartBody = styled.div`
  position: relative;
  flex: 1;
  min-height: 0;
`

export const ChartMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
  font-size: 14px;
  color: ${colors.gray400};
`
